import React from 'react';
import { Text } from '@gjensidige/builders-components';

import './CoverageDetails.scss';
interface CoverageDetailsProps {
  detailText: string;
  packageName?: string;
  packagePrice?: string;
}
export const CoverageDetails: React.FC<CoverageDetailsProps> = (
  props: CoverageDetailsProps
) => {
  return (
    <>
      <div className="additional-coverage-details">
        {props.detailText.split('\n').map((text: string, index: number) => {
          return (
            <Text
              size="body"
              className={text.trim().length > 0 ? '' : 'pt-1'}
              key={index}
            >
              {text}
            </Text>
          );
        })}
      </div>
    </>
  );
};
